import React, { Fragment } from "react";
import { inject } from "mobx-react";
import { Modal, Spin, Tooltip } from "antd";
import "../stylesheets/jobInfo.scss";

@inject("gameStore")
class JobInfo extends React.Component {
  state = {
    visible: false,
    // 岗位名字
    title: "",
    // 岗位职责
    duty: "",
    // 岗位要求
    requirement: "",
    // 岗位id
    id: "",
    // 岗位分类
    category: "",
    isLoading: true,
    // 岗位是否已下线
    isJdOffline: false,
  };

  fetchJobDetail = async (id, jobName) => {
    try {
      const res = await this.props.gameStore.fetchJobDetail(id, "Y");
      if (res && res.status === 0 && res.code === "S0000") {
        const {
          duty,
          requirement,
          category,
          positionClassification1,
          recruitmentTypeName,
          workCity,
          team,
        } = res;
        this.setState({
          duty: duty.split("\n"),
          requirement: requirement.split("\n"),
          category: [
            category,
            positionClassification1,
            recruitmentTypeName,
            workCity,
            team,
          ]
            .filter(Boolean)
            .join(" | "),
          isJdOffline: false,
        });
      } else if (res && res.code === "E0309") {
        // 职位已下线，并且是非开放窗口的职位
        this.setState({
          isJdOffline: true,
        });
      }
    } catch (error) {
      console.error(error);
    }
    this.setState({
      isLoading: false,
      title: jobName,
    });
  };

  showJD = (id, jobName) =>
    this.setState(
      {
        visible: true,
        isLoading: true,
      },
      () => this.fetchJobDetail(id, jobName)
    );

  closeModal = () =>
    this.setState({
      visible: false,
    });

  renderInfoList = (list) =>
    list.map((item, index) => {
      if (/^-/.test(item)) {
        return (
          <p className="jobInfoModal__content--textIn" key={index}>
            {item}
          </p>
        );
      }
      return (
        <p className="jobInfoModal__content--text" key={index}>
          {item}
        </p>
      );
    });

  emptyDom = (<p className="renderExpandedRow__title--item">{"暂无"}</p>);

  getJobName = (job) => {
    if (!job) return [];
    if (job.includes("^^")) {
      return job.split("^^");
    }
    return [job];
  };

  render() {
    const { input, uuid } = this.props;
    const {
      visible,
      title,
      isLoading,
      duty,
      requirement,
      category,
      isJdOffline,
    } = this.state;
    const [primaryJob, transferJob] = input.value.split("||");
    const [primaryJobName, primaryJobId] = this.getJobName(primaryJob);
    const [transferJobName, transferJobId] = this.getJobName(transferJob);

    return (
      <Fragment>
        {primaryJobName && primaryJobId ? (
          <div
            onClick={() => this.showJD(primaryJobId, primaryJobName)}
            className="my-inputs__item my-inputs__item-job"
            key={`gameformHistory-jobInfo-primaryJob-${uuid}`}
          >
            投递职位：
            <Tooltip title={primaryJobName}>{primaryJobName}</Tooltip>
          </div>
        ) : null}
        {transferJobName && transferJobId ? (
          <div
            onClick={() => this.showJD(transferJobId, transferJobName)}
            className="my-inputs__item my-inputs__item-job"
            key={`gameformHistory-jobInfo-transferJob-${uuid}`}
          >
            感兴趣的职位：
            <Tooltip title={transferJobName}>{transferJobName}</Tooltip>
          </div>
        ) : null}
        <Modal
          visible={visible}
          getContainer={false}
          footer={null}
          onCancel={this.closeModal}
          width={"50vw"}
          className={isLoading ? "jobInfoModal--loading" : "jobInfoModal"}
        >
          {isLoading ? (
            <Spin className="jobInfoModal--spin" />
          ) : isJdOffline ? (
            <div className="jobInfoModal--offline">{"职位已下线"}</div>
          ) : (
            <div className="jobInfoModal">
              <div className="jobInfoModal__title">{title}</div>
              {category ? (
                <div className="jobInfoModal__category">{category}</div>
              ) : null}
              <div className="jobInfoModal__content--title">{"工作职责"}</div>
              {duty.length > 0 ? this.renderInfoList(duty) : this.emptyDom}
              <div className="jobInfoModal__content--title">{"任职要求"}</div>
              {requirement.length > 0
                ? this.renderInfoList(requirement)
                : this.emptyDom}
            </div>
          )}
        </Modal>
      </Fragment>
    );
  }
}

export default JobInfo;



// WEBPACK FOOTER //
// ./src/components/formList/gameFormHistory/jobInfo.js